/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
import useConnectionContext from '@hooks/useConnectionContext';
import { useEffectOnce } from '@hooks';
import request from '@api';
import { usePlaidLink } from 'react-plaid-link';
import ConnectionCard from './ConnectionCard';
import { popupCenter } from '../../utils';

import classes from './Connection.module.css';

export const usePaymentConnection = () => {
  const { queryConnection, payment } = useConnectionContext();
  const [token, setToken] = useState(null);
  const isOAuthRedirect = window.location.href.includes('oauth_state_id=');

  // generate a link_token when component mounts
  useEffectOnce(() => {
    if (isOAuthRedirect) {
      setToken(localStorage.getItem('PLAID_LINK_TOKEN'));
      return;
    }
    const createLinkToken = async () => {
      const res = await request('create-plaid-link-token', { path: '/gateway/payment-service/api/open-platform/' }).catch(console.log);
      const { code, data: linkToken } = res || {};
      if (code === 0) {
        setToken(linkToken);
        localStorage.setItem('PLAID_LINK_TOKEN', linkToken);
      }
    };
    if (!payment.connected) {
      createLinkToken();
    }
  }, [isOAuthRedirect, payment.connected]);

  const plaidLinkConfig = {
    onSuccess: async (publicToken) => {
      await request('plaid-onboarding', { path: '/gateway/payment-service/api/open-platform/', method: 'POST', body: { publicToken } }).catch(console.log);
      await queryConnection();
    },
    onLoad: () => {
      console.log('plaid loaded');
    },
    token,
  };
  if (isOAuthRedirect) {
    plaidLinkConfig.receivedRedirectUri = window.location.href;
  }
  const { open, ready } = usePlaidLink(plaidLinkConfig);
  useEffectOnce(() => {
    if (isOAuthRedirect && ready) {
      open();
    }
  }, [ready, open, isOAuthRedirect]);

  return {
    openPlaidLink: open,
  };
};

function PaymentCard() {
  const {
    isLoading, payment,
  } = useConnectionContext();

  const { openPlaidLink } = usePaymentConnection();

  return <ConnectionCard isLoading={isLoading} data={payment} clickHandler={openPlaidLink} />;
}

function StoreCard() {
  const {
    isLoading, store,
  } = useConnectionContext();

  const storeClickHandler = () => {
    const shop = store.info;
    popupCenter({
      url: shop ? `https://${process.env.SHOPIFY_APP_INSALLATION_URI}?shop=${encodeURIComponent(shop)}` : '/connect-store', title: '', w: 800, h: 600,
    });
  };
  return (
    <ConnectionCard
      isLoading={isLoading}
      data={store}
      clickHandler={storeClickHandler}
    />
  );
}

function Connection() {
  return (
    <div className={classes.main}>
      <StoreCard />
      <PaymentCard />
    </div>
  );
}

export default Connection;
